import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCityListing = createAsyncThunk(
  "cityListing/getCityListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/city/get_all_data`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        {}
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const cityListSlice = createSlice({
  name: "cityListing",
  initialState: {
    loading: false,
    cityListingData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCityListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCityListing.fulfilled, (state, action) => {
        state.loading = false;
        state.cityListingData = action.payload;
      })
      .addCase(getCityListing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cityListSlice.reducer;
